import React from "react";

const ContactSection = () => {
  return (
    <>

      {/* Breadcrumb */}
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3>Contact Us</h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Area Start */}
      <section className="section_70" style={{ background: "#f7f7f7" }}>
        <div className="container">

          {/* Top 3 Cards */}
          <div className="row">

            {/* Phone Card */}
            <div className="col-12 col-md-4 mb-4">
              <div className="contact-card shadow-sm p-4" style={{ borderRadius: "12px", background: "#fff" }}>
                <h3 className="mb-3">
                  <i className="fa fa-phone" style={{ marginRight: 8 }}></i> Call Us
                </h3>

                <div className="mb-3">
                  <h5> Phone Number</h5>
                  <a href="tel:+91" class9819399797
Name="contact-link">+91 9819399797</a>
                </div>

                
              </div>
            </div>

            {/* Email Card */}
            <div className="col-12 col-md-4 mb-4">
              <div className="contact-card shadow-sm p-4" style={{ borderRadius: "12px", background: "#fff" }}>
                <h3 className="mb-3">
                  <i className="fa fa-envelope" style={{ marginRight: 8 }}></i> Email Us
                </h3>

                <div className="mb-3">
                  <h5>General Inquiry</h5>
                  <a href="mailto:booking@shambhucab.com" className="contact-link">booking@shambhucab.com</a>
                </div>

              </div>
            </div>

            {/* Address Card */}
            <div className="col-12 col-md-4 mb-4">
              <div className="contact-card shadow-sm p-4" style={{ borderRadius: "12px", background: "#fff" }}>
                <h3 className="mb-3">
                  <i className="fa fa-map-marker" style={{ marginRight: 8 }}></i> Address
                </h3>

                <p style={{ lineHeight: "1.6" }} className="text-dark">
                  <p className="text-dark">Shambhu Cabs</p>
                 Saket Tata Power CHS, Swami Samarth Marg, Juhu Nagar, Sector-16, Vashi, Navi Mumbai, Maharashtra India - 400703
                </p>

                <hr />

           
              </div>
            </div>

          </div>

          {/* Bottom Location Card */}
          <div className="row mt-4">
            <div className="col-12">
              <div
                className="contact-card shadow-sm p-4"
                style={{ borderRadius: "12px", background: "#fff" }}
              >
                <h3 className="mb-3">
                  <i className="fa fa-map" style={{ marginRight: 8 }}></i> Our Location
                </h3>

                <p className="mb-3">Find us on the map below:</p>

                <div style={{ width: "100%", height: "350px", borderRadius: "12px", overflow: "hidden" }}>
                  
          {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3770.7268196767427!2d73.0012643!3d19.075744900000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c10069d51255%3A0x212370c985b54f65!2sSaket%20Tata%20Power%20CHS!5e0!3m2!1sen!2sin!4v1765105944790!5m2!1sen!2sin" width="100%" height="100%" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}


          
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d397811.6763945419!2d72.69586406522716!3d19.075746183373056!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xaecf06ffbc56e61f%3A0x9987fb9eb65682d3!2sShambhu%20Cabs!5e1!3m2!1sen!2sin!4v1766463527185!5m2!1sen!2sin" width="100%" height="100%"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>


                </div>
              </div>
            </div>
          </div>

        </div>
      </section>
      {/* Contact End */}

    </>
  );
};

export default ContactSection;
